import { useMemo, useState } from "react";
import { battleDeck } from "@/mocks/homeData";

export default function BattleZone() {
  const [idx, setIdx] = useState(0);
  const [toast, setToast] = useState(false);
  const item = battleDeck[idx];

  const drawNext = () => {
    setIdx((prev) => {
      let next = Math.floor(Math.random() * battleDeck.length);
      if (battleDeck.length > 1) {
        while (next === prev) next = Math.floor(Math.random() * battleDeck.length);
      }
      return next;
    });
    setToast(false);
  };

  const copyCaption = async () => {
    try {
      await navigator.clipboard.writeText(`${item.title}｜${item.caption}｜来自52吃瓜`);
    } catch {
      /* ignore */
    }
    setToast(true);
    window.setTimeout(() => setToast(false), 1800);
  };

  const buttonCls = useMemo(
    () =>
      "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full px-5 py-2.5 text-sm font-semibold transition-colors cursor-pointer",
    []
  );

  return (
    <section id="battle" className="relative overflow-hidden bg-accent-900 py-14 md:py-20">
      <div className="watermelon-stripe absolute inset-y-0 left-0 w-2 opacity-60" />
      <div className="watermelon-stripe absolute inset-y-0 right-0 w-2 opacity-60" />
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
          <div className="text-background-50">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-background-50/15 px-3 py-1 text-xs font-semibold">
              <i className="ri-sword-fill" /> 斗图神器
            </span>
            <h2 className="mt-4 font-heading text-3xl leading-tight md:text-5xl">
              随机斗图
              <br />
              抽一张 直接把对方拿捏
            </h2>
            <p className="mt-4 max-w-md text-background-50/85">
              不知道回什么？一键抽取「52吃瓜」斗图素材库，选张顺手的神图甩回去，
              还能一键复制梗文案，让聊天更有来有回。
            </p>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row">
              <button
                type="button"
                onClick={drawNext}
                className={`${buttonCls} bg-secondary-500 text-foreground-950 hover:bg-secondary-400`}
              >
                <i className="ri-shuffle-line" />
                再抽一张
              </button>
              <button
                type="button"
                onClick={copyCaption}
                className={`${buttonCls} bg-background-50 text-accent-900 hover:bg-background-200`}
              >
                <i className="ri-file-copy-line" />
                复制梗文案
              </button>
            </div>
            <p className="mt-5 text-xs text-background-50/60">
              共收录斗图素材 {battleDeck.length} 套，越抽越有梗。
            </p>
          </div>

          <div className="relative mx-auto w-full max-w-sm">
            {toast && (
              <div className="absolute -top-3 left-1/2 z-10 -translate-x-1/2 whitespace-nowrap rounded-full bg-background-50 px-4 py-1.5 text-xs font-semibold text-accent-800 shadow-lg rise-in">
                ✅ 文案已复制到剪贴板
              </div>
            )}
            <div className="rise-in overflow-hidden rounded-[2rem] bg-background-50 p-3 shadow-2xl" key={item.id}>
              <img
                src={item.img}
                alt={item.alt}
                className="aspect-square w-full rounded-3xl object-cover object-top"
              />
              <div className="flex items-center justify-between gap-3 p-3">
                <div>
                  <h3 className="font-heading text-lg text-foreground-950">{item.title}</h3>
                  <p className="text-sm text-foreground-500">{item.caption}</p>
                </div>
                <span className="shrink-0 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-700">
                  {item.tag}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}